export default "__VITE_PUBLIC_ASSET__f583440e__"